import { graphql } from "../generated";

export const MUTATE_REPORT_ANIMATION = graphql(`
  mutation MutateReportAnimation($id: Int!, $reason: String!) {
    reportAnimation(id: $id, reason: $reason)
  }
`);
